<template>
  <div id="catalogs">
    <Datatable
      v-if="inventory"
      entity="catalog"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id}"
      :onRowClick="onRowClick"
      :globalActions="[
        {text: 'catalog.manage_company', method: goToCompanyCatalogs, condition: function() { return !$route.query.company}},
      ]"
      :rowActions="[{text: 'datatable.edit', method: onRowEdit}]">
    </Datatable>
  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";

  export default {
    name: "catalogs",

    components: { Datatable },

    computed: {
      inventory() {
        return this.$store.state.contextInventory;
      }
    },

    async created() {
      this.$store.state.pageTitleTranslationKey = "inventory.catalogs";
      this.$store.state.pageIcon = "/icon/menu.svg";
    },

    methods: {
      canManageCatalog() {
        let fields = this.$store.getters.getOverloadableFields;
        if (!this.$route.query.company || !this.$store.getters.isBranchContextInventory || fields.length === 0) {
          return false;
        }
        return fields.indexOf("catalogExclusions") > -1;
      },
      edit(id) {
        this.$router.push(this.$router.buildContext("/catalog/edit", {id}));
      },
      goToCompanyCatalogs() {
        this.$router.push(this.$router.buildContext("/catalog/company-catalogs", {branch: this.$route.query.branch}));
      },
      onRowClick(row) {
        this.edit(row.id)
      },
      onRowEdit(row) {
        this.edit(row.id)
      },
    }
  }

</script>

<style lang="scss" scoped>

</style>